export const payloadTypes = {
  countries: 59,
  states: 60,
  titles: 61,
  subscriberRequirements: 166,
  subscriberLeadSourceCode: 167,
  regex: 180,
};
